import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';

import AboutUs from './Pages/AboutUs';

const AboutUsRoutes = () => {
    return (
        <Fragment>
            <Route path="/aboutUs" component={AboutUs} />
        </Fragment>
    )
};

export default AboutUsRoutes;
